// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__DhJC-","signatureBlock":"Footer_signatureBlock__29t0g","signature":"Footer_signature__dgJMk"};